import { useBlocker } from '@tanstack/react-router';

export interface BloqueioAlteracoes {
  /** Navegacao interna bloqueada, aguardando confirmacao do usuario. */
  bloqueado: boolean;
  /** Confirma a saida e segue a navegacao bloqueada. */
  sair: () => void;
  /** Cancela a saida e fica na tela. */
  ficar: () => void;
}

/**
 * Avisa ao sair de um registro com alteracoes: bloqueia a navegacao interna do TanStack Router
 * (com confirmacao via `bloqueado`/`sair`/`ficar`) e o fechamento/recarga da aba (beforeunload).
 */
export function useBlockerDirty(dirty: boolean): BloqueioAlteracoes {
  const blocker = useBlocker({
    shouldBlockFn: () => dirty,
    enableBeforeUnload: () => dirty,
    withResolver: true,
  });

  return {
    bloqueado: blocker.status === 'blocked',
    sair: () => {
      if (blocker.status === 'blocked') blocker.proceed();
    },
    ficar: () => {
      if (blocker.status === 'blocked') blocker.reset();
    },
  };
}
